// Platform logo URLs - used across settings, docs, and publishing
export const PLATFORM_IMAGES = {
  wordpress: 'https://ancujowsxivyfnxhnsmr.supabase.co/storage/v1/object/public/images/WordPress_blue_logo.svg',
  shopify: 'https://ancujowsxivyfnxhnsmr.supabase.co/storage/v1/object/public/images/shopify-logo.svg',
  wix: 'https://ancujowsxivyfnxhnsmr.supabase.co/storage/v1/object/public/images/wix.svg',
  webflow: 'https://ancujowsxivyfnxhnsmr.supabase.co/storage/v1/object/public/images/Mark_Logo_Blue.svg',
  framer: 'https://ancujowsxivyfnxhnsmr.supabase.co/storage/v1/object/sign/random%20images/framer.svg?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xOWQwMmZkMy05MzllLTQ3YWYtODEyYS0zOWQxMTc0NGY2N2IiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJyYW5kb20gaW1hZ2VzL2ZyYW1lci5zdmciLCJpYXQiOjE3NjQyNDc1NzksImV4cCI6MTkyMTkyNzU3OX0.Gu1gIBRsicbTGv-BvevnBi8YCteGS7cUz35GMijvz7c',
} as const;


